import type { DigitsRoute, RouteParams } from "@digits-shared/components/Router/DigitsRoute"
import { useRoutePathAndMatch } from "@digits-shared/components/Router/useRoutePathAndMatch"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"

export function useFrontendPathAndMatch(route: DigitsRoute, params?: RouteParams) {
  const pathGenerator = useFrontendPathGenerator()
  return useRoutePathAndMatch(pathGenerator, route, params)
}
